import type {
  MemberPromotionDrawerContext as MemberPromotionDrawerContextType,
  MemberPromotionTableContext as MemberPromotionTableContextType
} from '@library/types/members/memberPromotions';
import { createContext } from 'react';

export const MemberPromotionTableContext =
  createContext<MemberPromotionTableContextType>({
    memberPromotionTypeOptions: [],
    onClickPromotion: () => {}
  });

export const MemberPromotionDrawerContext =
  createContext<MemberPromotionDrawerContextType>({
    memberId: '',
    onClosePromotionsDrawer: () => {},
    onClickEntryId: () => {},
    promotionId: ''
  });
